 const role = localStorage.getItem("role");
const isAdmin = role === "admin";

export const STATUS_OPTIONS = [
  { value: "New", color: "bg-blue-500", bgLight: "bg-blue-100", textColor: "text-blue-800" },
  { value: "Pending", color: "bg-yellow-500", bgLight: "bg-yellow-100", textColor: "text-yellow-800" },
  { value: "Assigned", color: "bg-indigo-500", bgLight: "bg-indigo-100", textColor: "text-indigo-800" },
  { value: "Contacted", color: "bg-cyan-500", bgLight: "bg-cyan-100", textColor: "text-cyan-800" },
  { value: "completed", color: "bg-cyan-500", bgLight: "bg-cyan-100", textColor: "text-cyan-800" },
  { value: "Follow-up", color: "bg-orange-500", bgLight: "bg-orange-100", textColor: "text-orange-800" },
  { value: "Interested", color: "bg-green-500", bgLight: "bg-green-100", textColor: "text-green-800" },
  { value: "Not Interested", color: "bg-red-500", bgLight: "bg-red-100", textColor: "text-red-800" },
  { value: "Callback Requested", color: "bg-pink-500", bgLight: "bg-pink-100", textColor: "text-pink-800" },
  { value: "No Response", color: "bg-gray-500", bgLight: "bg-gray-100", textColor: "text-gray-800" },
  { value: "Meeting", color: "bg-purple-500", bgLight: "bg-purple-100", textColor: "text-purple-800" },
  { value: "Converted", color: "bg-emerald-600", bgLight: "bg-emerald-100", textColor: "text-emerald-800" },
  { value: "Lost", color: "bg-slate-600", bgLight: "bg-slate-100", textColor: "text-slate-800" },
];
const ALL_STATUS_OPTIONS = [
  { value: "New", color: "bg-blue-500", bgLight: "bg-blue-100", textColor: "text-blue-800" },
  { value: "Pending", color: "bg-yellow-500", bgLight: "bg-yellow-100", textColor: "text-yellow-800" },
  { value: "Assigned", color: "bg-indigo-500", bgLight: "bg-indigo-100", textColor: "text-indigo-800" },
  { value: "Contacted", color: "bg-cyan-500", bgLight: "bg-cyan-100", textColor: "text-cyan-800" },
  { value: "Follow-up", color: "bg-orange-500", bgLight: "bg-orange-100", textColor: "text-orange-800" },
  { value: "Interested", color: "bg-green-500", bgLight: "bg-green-100", textColor: "text-green-800" },
  { value: "Not Interested", color: "bg-red-500", bgLight: "bg-red-100", textColor: "text-red-800" },
  { value: "Callback Requested", color: "bg-pink-500", bgLight: "bg-pink-100", textColor: "text-pink-800" },
  { value: "No Response", color: "bg-gray-500", bgLight: "bg-gray-100", textColor: "text-gray-800" },
  { value: "Meeting", color: "bg-purple-500", bgLight: "bg-purple-100", textColor: "text-purple-800" },
  { value: "Converted", color: "bg-emerald-600", bgLight: "bg-emerald-100", textColor: "text-emerald-800" },
  { value: "Lost", color: "bg-slate-600", bgLight: "bg-slate-100", textColor: "text-slate-800" },
];

export const SUB_STATUS_OPTIONS = [
  { value: "New", label: "New", color: "bg-red-400", bgLight: "bg-red-100", textColor: "text-red-800" },
  { value: "Budget issue", label: "Budget issue", color: "bg-red-400", bgLight: "bg-red-100", textColor: "text-red-800" },
  { value: "Competitor selected", label: "Competitor selected", color: "bg-orange-400", bgLight: "bg-orange-100", textColor: "text-orange-800" },
  { value: "Fake lead", label: "Fake lead", color: "bg-gray-400", bgLight: "bg-gray-100", textColor: "text-gray-800" },
  { value: "Duplicate", label: "Duplicate", color: "bg-purple-400", bgLight: "bg-purple-100", textColor: "text-purple-800" },
  { value: "Wrong number", label: "Wrong number", color: "bg-pink-400", bgLight: "bg-pink-100", textColor: "text-pink-800" },
  { value: "Not interested", label: "Not interested", color: "bg-red-500", bgLight: "bg-red-100", textColor: "text-red-800" },
  { value: "No response", label: "No response", color: "bg-gray-500", bgLight: "bg-gray-100", textColor: "text-gray-800" },
  { value: "Call tomorrow", label: "Call tomorrow", color: "bg-yellow-500", bgLight: "bg-yellow-100", textColor: "text-yellow-800" },
  { value: "After salary", label: "After salary", color: "bg-green-400", bgLight: "bg-green-100", textColor: "text-green-800" },
  { value: "Quotation needed", label: "Quotation needed", color: "bg-blue-400", bgLight: "bg-blue-100", textColor: "text-blue-800" },
  { value: "Waiting decision", label: "Waiting decision", color: "bg-indigo-400", bgLight: "bg-indigo-100", textColor: "text-indigo-800" },
];

export const SOURCE_OPTIONS = [
  { value: "", label: "All Sources" },
  { value: "Website", label: "Website" },
  { value: "Referral", label: "Referral" },
  { value: "Cold Call", label: "Cold Call" },
];

export const STATUS_BADGE = {
  New: "badge-blue",
  Pending: "badge-yellow",
  Assigned: "badge-indigo",
  Contacted: "badge-cyan",
  "Follow-up": "badge-orange",
  Interested: "badge-green",
  "Not Interested": "badge-red",
  "Callback Requested": "badge-pink",
  "No Response": "badge-gray",
  Meeting: "badge-purple",
  Converted: "badge-emerald",
  Lost: "badge-slate",
};

export const PAYMENT_STATUS_BADGE = {
  paid: "badge-green",
  partial: "badge-yellow",
  completed: "badge-green",
  pending: "badge-red",
  processing: "badge-blue",
  overdue: "badge-slate",
  failed: "badge-red",
  cancelled: "badge-red",
  // cancelled: "badge-gray",
  refunded: "badge-indigo",
  "partially refunded": "badge-purple",
  "on hold": "badge-orange",
};


// Subscription-specific statuses
export const SUBSCRIPTION_STATUS_OPTIONS = [
  { value: "active",    label: "Active",    color: "bg-green-500",  bgLight: "bg-green-100",  textColor: "text-green-800" },
  { value: "expired",   label: "Expired",   color: "bg-red-500",    bgLight: "bg-red-100",    textColor: "text-red-800" },
  { value: "pending",   label: "Pending",   color: "bg-yellow-500", bgLight: "bg-yellow-100", textColor: "text-yellow-800" },
  { value: "cancelled", label: "Cancelled", color: "bg-gray-500",   bgLight: "bg-gray-100",   textColor: "text-gray-800" },
];

export const SUBSCRIPTION_PAYMENT_METHODS = [
  { value: "cash",   label: "Cash" },
  { value: "online", label: "Online" },
  { value: "upi",    label: "UPI" },
  { value: "card",   label: "Card" },
];
export const STATUS_OPTIONS_d = isAdmin
  ? ALL_STATUS_OPTIONS
  : ALL_STATUS_OPTIONS.filter(
      (status) => !["New", "Assigned"].includes(status.value)
    );